import { WeekDayNum } from "../model/week-day";

export enum LIST_TIMERS_TABLE_COLUMNS {
    NAME = 'name',
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at',
    ACTIONS = 'actions'
}
export const LIST_TIMERS_TABLE_HEADER = [
    LIST_TIMERS_TABLE_COLUMNS.NAME,
    LIST_TIMERS_TABLE_COLUMNS.CREATED_AT,
    LIST_TIMERS_TABLE_COLUMNS.UPDATED_AT,
    LIST_TIMERS_TABLE_COLUMNS.ACTIONS
];

export const LIST_TIMERS_DEFAULT_SORT_COLUMN = LIST_TIMERS_TABLE_COLUMNS.NAME;
export const LIST_TIMERS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const LIST_TIMERS_PAGE_SIZE_OPTIONS = [5, 10];
export const LIST_TIMERS_PAGE_DEFAULT_SIZE = 10;


export const WEEK_DAYS_TIMERS: WeekDayNum[] = [
    { Value: 0, Name: 'MON' },
    { Value: 1, Name: 'TUE' },
    { Value: 2, Name: 'WED' },
    { Value: 3, Name: 'THU' },
    { Value: 4, Name: 'FRI' },
    { Value: 5, Name: 'SAT' },
    { Value: 6, Name: 'SUN' },
    { Value: 7, Name: 'SPECIAL' }
];


export enum LIST_SPECIAL_DAY_TABLE_COLUMNS {
    DATE = 'date',
    MODALITY = 'modality',
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at'
}
export const LIST_SPECIAL_DAY_TABLE_HEADER = [
    LIST_SPECIAL_DAY_TABLE_COLUMNS.DATE,
    LIST_SPECIAL_DAY_TABLE_COLUMNS.MODALITY,
    LIST_SPECIAL_DAY_TABLE_COLUMNS.CREATED_AT,
    LIST_SPECIAL_DAY_TABLE_COLUMNS.UPDATED_AT
];

export const LIST_SPECIAL_DAY_DEFAULT_SORT_COLUMN = LIST_SPECIAL_DAY_TABLE_COLUMNS.DATE;
export const LIST_SPECIAL_DAY_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const LIST_SPECIAL_DAY_PAGE_SIZE_OPTIONS = [5, 10];
export const LIST_SPECIAL_DAY_PAGE_DEFAULT_SIZE = 10;


export class SpecialDayModality {
    Value: number;
    Name: string;
}

export const SPECIAL_DAY_MODALITY: SpecialDayModality[] = [
    { Value: 0, Name: 'DISABLED' },
    { Value: 1, Name: 'ENABLE' },
    { Value: 2, Name: 'CUSTOM' },
];
